import React, {  useMemo } from "react";
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  Button,
  ModalHeader,
  ModalOverlay,
 
  Box,
} from "@chakra-ui/react";
import { Col, Row } from "react-bootstrap";
import dateTimeFormat from "jsFunctions/dateTimeFormat";

import { formatAmountInINR } from "jsFunctions/formatAmountInINR";
import SpentAmountTable from "./dataChangeTable/spentAmount";
import RefundAmountTable from "./dataChangeTable/refundAmountTable";

const DirectTaxDataChangeModal = ({
  openModal,
  closeModal,
  editData,
  currentData,
  isConfirmed,
  role
}) => {
  const getcurrectData = Object.fromEntries(
    Array.from(currentData?.entries() || []).map(([key, value]) => [
      key,
      key === "payInfo" ? JSON.parse(value) : value,
    ])
  );

  const currentSpentInfo = useMemo(() => {
    if (getcurrectData?.payInfo) {
      return getcurrectData.payInfo.map(item => item);
    }
    return [];
  }, [getcurrectData]);

  const editSpentInfo = useMemo(() => {
    if (editData?.pyInfo?.list) {
      const currSpentData = getcurrectData?.payInfo || [];
      const spentData = editData.pyInfo.list || [];
      const dummObjectCount = currSpentData.length - spentData.length;

      return [
        ...spentData,
        ...Array(Math.max(0, dummObjectCount)).fill({}),
      ];
    }
    return [];
  }, [getcurrectData, editData]);

  const currentRefundInfo = useMemo(() => {
    if (getcurrectData?.refundInfo) {
      const refundData = JSON.parse(getcurrectData.refundInfo) || [];
      return refundData.map(item => item);
    }
    return [];
  }, [getcurrectData]);

  const editRefundInfo = useMemo(() => {
    if (editData?.rfdInfo?.list) {
      const refundData = editData.rfdInfo.list || [];
      const currrefundData = JSON.parse(getcurrectData?.refundInfo || '[]') || [];
      const dummObjectCount = currrefundData.length - refundData.length;

      return [
        ...refundData,
        ...Array(Math.max(0, dummObjectCount)).fill({}),
      ];
    }
    return [];
  }, [getcurrectData, editData]);


  console.log(getcurrectData,'current')
  return (
    <>
      <Modal
        isOpen={openModal}
        onClose={closeModal}
        size="xl"
        className="modal-main data-change-model"
        scrollBehavior={"inside"}
        
        
      >
        <ModalOverlay />
        <ModalContent 
         top="0" // Position it at the top
          margin="0 auto" // Center it horizontally
          bottom="0"
        className="data-change-content info-model"
>
          <ModalHeader className="expense-modal-header data-change-modal-header">
            <>
              {/* Compare fields */}
              <Row className="modal-header-row">
                <Col>
                  <h6>
                    Current
                  </h6>
                </Col>
                
                <Col>
                  <h6 >
                    Edited
                  </h6>
                </Col>
              </Row>
            </>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody className="data-change-body">
            <Row className="data-change-body-row">
              <Col className="row-col">
                <div className="row-table">
                  <Row className="rowC">
                        <h4 className="row-heading">
                          Purchase Order Details :
                        </h4>
                      </Row>
                  <Row className="rowC">
                    <Col>
                      Order Month : {dateTimeFormat(editData.oM)}
                    </Col>
                  </Row>
                  <Row className="rowC">
                    <Col>Order Date : {dateTimeFormat(editData.oM)}</Col>
                  </Row>
                 
                   
                  <Row className="rowC">
                        <Col className={`${editData?.rcId?._id !== getcurrectData?.receiverId ? 'data_compare_red' : '' }`}>Receiver Id : {editData?.rcId?._id}</Col>
                      </Row>
                     
                      <Row className="rowC">
                        <Col className={`${Number(editData?.tlTx || 0) !== Number(getcurrectData?.totalTax || 0)  ? 'data_compare_green' : '' }`}>
                        <Box display="flex">Total Tax:{formatAmountInINR(parseFloat(editData?.tlTx || 0))}</Box></Col>
                      </Row>
                      <Row className="rowC">
                        <Col className={`${editData.rmks !== getcurrectData.remarks  ? 'data_compare_red' : '' }`}>Remarks : {editData.rmks}</Col>
                      </Row>
                      
                      <Row className="rowC">
                        <h4
                          className="row-heading"
                        >
                          Payment Information : 
                        </h4>
                      </Row>
                      <Row className="rowC">
                        <Col className={`${Number(editData?.pyInfo?.apAmt) !== Number(getcurrectData?.approvalAmount)  ? 'data_compare_red' : '' }`}>
                            <Box display="flex">
                            Requested Amount : {formatAmountInINR(editData?.pyInfo?.apAmt)}
                            </Box>
                        </Col>
                      </Row>

                     <SpentAmountTable editSpentInfo={editSpentInfo} currentSpentInfo={currentSpentInfo} type="current" />
                 
                 
               

                    

                     {(role === "Manager" || role === "Admin") &&
                     <>
                      <Row className="rowC">
                        <h4
                          className="row-heading" 
                        >
                          Refund Information : 
                        </h4>
                      </Row>
                      <RefundAmountTable editRefundInfo={editRefundInfo} currentRefundInfo={currentRefundInfo} type="current"/>
                     </>
}

                  
                     
                      
                  
                  
                   
                </div>
              </Col>
              <Col className="row-col">
                <div className="row-table">
                <Row className="rowC">
                        <h4
                         className="row-heading"
                        >
                          Purchase Order Details :
                        </h4>
                      </Row>
                  <Row className="rowC">
                    <Col>
                      Order Month : {dateTimeFormat(getcurrectData.orderMonth)}
                    </Col>
                  </Row>
                  <Row className="rowC">
                    <Col>
                      Order Date : {dateTimeFormat(getcurrectData.orderDate)}
                    </Col>
                  </Row>
                  <Row className="rowC">
                        <Col className={`${editData?.rcId?._id !== getcurrectData?.receiverId  ? 'data_compare_green' : '' }`}>Receiver Id: {getcurrectData?.receiverId}</Col>
                      </Row>
                      <Row className="rowC">
                        <Col className={`${editData?.tlTx != getcurrectData?.totalTax  ? 'data_compare_green' : '' }`}>
                        <Box display="flex">Total Tax:{formatAmountInINR(parseFloat(getcurrectData?.totalTax || 0))}</Box>

                        </Col>
                      </Row>
                      <Row className="rowC">
                        <Col className={`${editData.rmks !== getcurrectData.remarks  ? 'data_compare_green' : '' }`}>Remarks : {getcurrectData.remarks}</Col>
                      </Row>
                      
                     
                  
                     
                      
                     
                      
                      <Row className="rowC">
                        <h4
                          className="row-heading"
                        >
                          Payment Information :
                        </h4>
                      </Row>
                      <Row className="rowC">
                        <Col className={`${Number(editData?.pyInfo?.apAmt || 0) !== Number(getcurrectData?.approvalAmount || 0)  ? 'data_compare_green' : '' }`}>
                        <Box display="flex">

                        Requested Amount : {formatAmountInINR(parseFloat(getcurrectData?.approvalAmount))}
                        </Box>
                        </Col>
                      </Row>
                
                    <SpentAmountTable editSpentInfo={editSpentInfo} currentSpentInfo={currentSpentInfo} type="edited" />
            
                    {(role === "Manager" || role === "Admin") &&
                    <>
                  <Row className="rowC">
                        <h4
                          className="row-heading" 
                        >
                          Refund Information : 
                        </h4>
                      </Row>
                      <RefundAmountTable editRefundInfo={editRefundInfo} currentRefundInfo={currentRefundInfo} type="edited"/>
                    </>
                    }
                </div>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter className="border-2 p-0 pt-4 pb-2">
            <Button
              type="submit"
              className="submit-btn"
              variant="brand"
              style={{ background: "#191063", minWidth: "100px" }}
              onClick={() => {
                isConfirmed();
                closeModal();
              }}
            >
              ok
            </Button>
            <Button
              type="submit"
              className="submit-btn"
              variant="brand"
              style={{ background: "#191063", minWidth: "100px" }}
              onClick={() => {
                closeModal();
              }}
            >
              cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default DirectTaxDataChangeModal;
